import React, { useEffect, useState } from "react"
import { Modal, Form, Input, Row, Col, Select } from "antd"
import moment from 'moment'
import { getKeySessionStorage, getSesion, sendServer, toast } from '../../utils/utils'
const { Option } = Select

const ValoracionAdd = ({ visible, setVisible, loadData, dataUpd, setDataUpd }) => {

  const [form] = Form.useForm();
  const [metodo, setMetodo] = useState('');

  useEffect(() => {
    const flagMetodo = dataUpd?.id ? 'actualizar' : 'agregar';
    setMetodo(flagMetodo);
    if (flagMetodo === 'actualizar') {
      form.setFieldsValue({
        ...dataUpd,
        fecha: moment(dataUpd.fecha).format('YYYY-MM-DD'),
      })
    } else {
      form.setFieldsValue({ fecha: moment().format('YYYY-MM-DD') })
    }
    return () => {
      setDataUpd({});
      form.setFieldsValue({});
    }
  }, [visible])

  const handleSubmit = async (item) => {

    try {
      const valid = otrosDatos(item);
      if (valid !== 'ok') {
        throw Error(valid);
      }
      const { msg } = await sendServer(item, 'POST', `master/valoracion/${metodo}`);
      loadData();
      toast('success', 'fitconluapp', 'Guardado correctamente');
      closeModal();
    } catch (e) {
      toast('warning', 'fitconluapp', `No se puede guardar, ${e.message}`);
    }

  };

  /**
   * valida el ro para poder agregar
   * @param {*} item 
   */
  const otrosDatos = (item) => {
    const { rol } = getSesion();
    const { idHistoria } = getKeySessionStorage('filtroHijos') || '';
    const { id } = getKeySessionStorage('historiaSelecionada') || '';
    if (rol === 'admin') {
      if (!idHistoria) {
        return 'debe haber una historia clínica'
      }
      item.idHistoriaClinica = idHistoria;
    } else {
      if (!id) {
        return 'debe haber una historia clínica'
      }
      item.idHistoriaClinica = id;
    }
    return 'ok';
  }

  const closeModal = () => {
    form.resetFields();
    setVisible(false);
  }

  return (
    <Modal
      title="Agregar valoración"
      visible={visible}
      width={1000}
      onOk={form.submit}
      onCancel={() => { closeModal() }}
      destroyOnClose={true}
      okText={"Guardar"}
      cancelText={"Cancelar"}
    >
      <Form
        name="frmValoracion_add"
        onFinish={handleSubmit}
        form={form}
      >
        <Row gutter="24">

          {/* ID */}
          <Form.Item
            name="id"
            rules={[
              { required: false },
            ]}
            hidden={true}
          >
            <Input />
          </Form.Item>

          {/* ID historia clinica */}
          <Form.Item
            name="idHistoriaClinica"
            rules={[
              { required: false },
            ]}
            hidden={true}
          >
            <Input />
          </Form.Item>

          {/* tipoValoracion */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              name="valoracion"
              label="Valoración"
              labelCol={{ span: 24 }}
              hasFeedback
              rules={[
                { required: true, message: "¡Valor obligatorio!" },
              ]}
            >
              <Select>
                {
                  window.tipoValoracion.map((op) => {
                    return (
                      <Option key={op} value={op}>
                        {op}
                      </Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>

          {/* FECHA PROGRAMACION */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label={"Fecha"}
              labelCol={{ span: 24 }}
              name="fecha"
              rules={[
                { required: true, message: "¡Valor obligatorio!" },
              ]}
            >
              <Input type="date" style={{ width: '100%', height: '30px' }} />
            </Form.Item>
          </Col>

          {/* Medida */}
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label={"Medida"}
              labelCol={{ span: 24 }}
              name="medida"
              rules={[
                { required: true, message: "¡Valor obligatorio!" },
              ]}
            >
              <Input  placeholder="Medida" />
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
  );
};

export default ValoracionAdd;
